// extracted by mini-css-extract-plugin
export default {"wrapper":"MB-z","button":"NB-z","alternate":"OB-z","disabled":"PB-z","paymentWarning":"QB-z","fadeIn":"RB-z"};